import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Scrollbar, EffectFade, EffectCube, EffectCoverflow, EffectFlip, FreeMode, Keyboard, Mousewheel, Thumbs, History } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cube';
import 'swiper/css/effect-coverflow';
import 'swiper/css/effect-flip';
import 'swiper/css/free-mode';

/**
 * Initialize Gallery Swiper blocks
 */
function initGallerySwipers() {
	const sliders = document.querySelectorAll('.wp-block-dapd-gallery .swiper-container');

	sliders.forEach((swiperContainer) => {
		// Prevent double initialization
		if (swiperContainer.swiper) {
			return;
		}

		// Get configuration from data attribute
		let config = {};
		try {
			const configData = swiperContainer.dataset.swiper;
			if (!configData) {
				console.warn('No swiper config found for gallery container', swiperContainer);
				return;
			}
			config = JSON.parse(configData);
		} catch (e) {
			console.error('Error parsing gallery swiper config:', e);
			config = {
				slidesPerView: 1,
				spaceBetween: 30,
				loop: true
			};
		}

		// Build modules array based on what features are enabled
		const modules = [];

		if (config.navigation) modules.push(Navigation);
		if (config.pagination) modules.push(Pagination);
		if (config.scrollbar) modules.push(Scrollbar);
		if (config.autoplay) modules.push(Autoplay);
		if (config.freeMode) modules.push(FreeMode);
		if (config.keyboard) modules.push(Keyboard);
		if (config.mousewheel) modules.push(Mousewheel);
		if (config.history) modules.push(History);

		// Add effect modules
		if (config.effect === 'fade') modules.push(EffectFade);
		if (config.effect === 'cube') modules.push(EffectCube);
		if (config.effect === 'coverflow') modules.push(EffectCoverflow);
		if (config.effect === 'flip') modules.push(EffectFlip);

		// Handle thumbs initialization
		if (config.thumbsSelector) {
			const thumbsElement = document.querySelector(config.thumbsSelector + ' .swiper-container');

			if (thumbsElement) {
				const thumbsSwiper = new Swiper(thumbsElement, {
					modules: [FreeMode],
					spaceBetween: 10,
					slidesPerView: 4,
					freeMode: true,
					watchSlidesProgress: true,
				});

				config.thumbs = {
					swiper: thumbsSwiper
				};

				modules.push(Thumbs);
			}

			delete config.thumbsSelector;
		}

		config.modules = modules;

		const swiperInstance = new Swiper(swiperContainer, config);

		// Handle custom parallax
		if (config.parallax) {
			const swiperBlock = swiperContainer.closest('.wp-block-dapd-gallery');
			const parallaxElements = swiperBlock ? swiperBlock.querySelectorAll('.parallax-bg') : [];

			parallaxElements.forEach((parallaxBg) => {
				const parallaxAmount = parallaxBg.getAttribute('data-swiper-parallax') || '-23%';
				const parallaxValue = parseFloat(parallaxAmount);
				const isPercentage = parallaxAmount.includes('%');

				swiperInstance.on('progress', (swiper, progress) => {
					let translateValue;

					if (isPercentage) {
						const bgWidth = parallaxBg.offsetWidth;
						translateValue = (progress * parallaxValue * bgWidth) / 100;
					} else {
						translateValue = progress * parallaxValue;
					}

					parallaxBg.style.transform = `translate3d(${translateValue}px, 0, 0)`;
				});

				parallaxBg.style.transform = 'translate3d(0, 0, 0)';
			});
		}
	});
}

// Initialize on DOMContentLoaded
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initGallerySwipers);
} else {
	initGallerySwipers();
}

// Also initialize when blocks are added in the editor or via other AJAX methods
if (window.wp && window.wp.domReady) {
	window.wp.domReady(initGallerySwipers);
}
